export default function mapResendOtpPayload(email) {
  return {
    email: email.trim().toLowerCase(),
    purpose: "login",
  };
}